import { useTranslation } from 'react-i18next'
import { i18n } from '@fs/zion-locale'
import { usePermission, useShowTemple } from '@fs/zion-permissions'

export default function useLearningLinks({ nonReligiousMode, isCoreLanguage, canAddPersonalData }) {
  const { t } = useTranslation()
  const [isMember] = usePermission('FtMemberUiPermission')
  const [showTemple] = useShowTemple()

  return {
    id: 'learning',
    title: t('nav.learning', 'Guidance and Learning'),
    subNav: [
      {
        id: 'gettingStrtd',
        text: t('nav.links.learning.gettingStrtd', 'Getting Started'),
        url: '/gettingstarted/',
        linkName: 'ff_lrn_gettingStrtd',
        dataTestId: 'ff_getting_started',
        isNew: false,
      },
      {
        id: 'rootsTech',
        text: t('nav.links.learning.rootsTech', 'RootsTech Conference'),
        url: '/rootstech/home',
        linkName: 'ff_lrn_rootsTech',
        dataTestId: 'ff_rootstech_conf',
        isNew: false,
        hidden: !isCoreLanguage,
      },
      {
        id: 'new',
        text: t('nav.links.learning.new', `What's New`),
        url: `/${i18n.language}/blog/tag/about-familysearch/whats-new-at-familysearch/`,
        linkName: 'ff_lrn_new',
        dataTestId: 'ff_whats_new',
        isNew: false,
        hidden: nonReligiousMode || !isCoreLanguage,
      },
      {
        id: 'learnCntr',
        text: t('nav.links.learning.learnCntr', 'Learning Center'),
        url: '/help/helpcenter/learning-center',
        linkName: 'ff_lrn_learnCntr',
        dataTestId: 'ff_learning_center',
        isNew: false,
      },
      {
        id: 'wiki',
        text: t('nav.links.learning.wiki', 'Genealogy Research Wiki'),
        url: `/${i18n.language}/wiki/Main_Page`,
        linkName: 'ff_lrn_wiki',
        dataTestId: 'ff_gen_res_wiki',
        isNew: false,
        hidden: nonReligiousMode,
      },
      {
        id: 'youtube',
        text: t('nav.links.learning.youtube', 'YouTube Channel'),
        url: 'https://www.youtube.com/c/familysearch/featured',
        linkName: 'ff_lrn_youtube',
        dataTestId: 'ff_youtube_channel',
        isNew: false,
        hidden: !isCoreLanguage,
      },
      {
        id: 'consultations',
        text: t('nav.links.learning.consultations', 'Free Virtual Consultations'),
        url: `https://www.familysearch.org/${i18n.language}/library/research-help` /* Prod link since this is not on beta */,
        linkName: 'ff_lrn_consult',
        dataTestId: 'ff_free_v_consultations',
        isNew: false,
        hidden: nonReligiousMode || !isCoreLanguage || !canAddPersonalData,
      },
      {
        id: 'blog',
        text: t('nav.blog', 'Blog'),
        url: `/${i18n.language}/blog/`,
        linkName: 'ff_lrn_blog',
        dataTestId: 'ff_blog',
        isNew: false,
        hidden: nonReligiousMode || !isCoreLanguage,
      },
      {
        id: 'helperRsc',
        text: isMember
          ? t('nav.links.involved.helperRsc', 'Helper Resources')
          : t('nav.links.involved.helpfulRsc', 'Helpful Resources'),
        url: '/help/helper',
        linkName: 'ff_inv_helperRsc',
        dataTestId: 'ff_helpful_resources',
        isNew: false,
        hidden: (isMember && showTemple) || !canAddPersonalData,
      },
    ],
  }
}
